/**
 *
 * ManduSurveyBoxMandu
 *
 */

import React from "react"
import "./index.less"
import lockTemplate from "../../images/lock-template.svg"

const SurveyBoxMandu = (props) => {
  return (
    <div
      onClick={() => props.onClick()}
      className="survey-mandu-box"
      style={{ backgroundImage: `url(${props.item.box_background_image})` }}>
      <div className="survey-mandu-box-title">
        <img src={props.item.box_company_logo} />
        <p>{props.item.name}</p>
      </div>
      <div className="survey-mandu-box-footer">
        <span>{props.item.questions.questions} preguntas</span>
      </div>
      {/* { props.item.survey_type === 'Liderazgo' && */}
      {props.item.survey_type === "locked" && (
        <div className="survey-mandu-box-lock">
          <img src={lockTemplate} />
        </div>
      )}
    </div>
  )
}

SurveyBoxMandu.propTypes = {}

export default SurveyBoxMandu
